export default __webpack_public_path__ + "static/media/4.43643e59.png";